import { render, staticRenderFns } from "./AlertTarget.vue?vue&type=template&id=6021c173&scoped=true&"
import script from "./AlertTarget.vue?vue&type=script&lang=ts&"
export * from "./AlertTarget.vue?vue&type=script&lang=ts&"
import style0 from "./AlertTarget.vue?vue&type=style&index=0&id=6021c173&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021c173",
  null
  
)

export default component.exports